module.exports = __webpack_public_path__ + "img/foto2.4ab06385.webp";